<template>
  <input
    type="text"
    v-model="text"
    :required="$props.required"
    @keyup="onChange()"
    @keyup.enter="$emit('onEnter')"
    @change="$emit('change')"
    @focus="onFocus"
    @blur="onBlur"
    @click="onFocus"
    :autofocus="autofocus"
  />
</template>
<script>
export default {
  name: "MoneyInput",
  props: [
    "value",
    "required",
    "max",
    "min",
    "allowZero",
    "autofocus",
    "exchangeRate",
    "decimal",
  ],
  data: () => {
    return {
      text: "",
    }
  },
  mounted() {
    this.text = this.$formatMoney(this.value, false, this.decimal, true)
  },
  watch: {
    value() {
      this.text = this.$formatMoney(this.value, false, this.decimal, true)
    },
  },
  methods: {
    onFocus(e) {
      e.target.select()
      this.$emit("focus")
    },
    onBlur(e) {
      this.$emit("blur")
    },
    focus() {},
    convert(s) {
      const n = s.replace(/[^.\d]/g, "").match(/^\d+\.?\d*/)
      return n ? n[0] : ""
    },
    onChange() {
      let number = this.convert(this.text)
      if (number === "") {
        this.$emit("input", null)
        this.$emit("keyup")
        this.$emit("change")
        return
      }

      const decimal = this.decimal || 1

      number = Math.round(number * decimal) / decimal
      if ((this.max || this.allowZero) && number > this.max) {
        number = this.max
      }
      if ((this.min || this.allowZero) && number < this.min) {
        number = this.min
      }
      const dotIndex = this.text.indexOf(".")
      const formattedBase = this.$formatMoney(number, false, decimal, true)
      if (dotIndex !== -1) {
        const maxDecimals = Math.round(Math.log10(decimal))
        const rawDecimal = this.text.slice(dotIndex + 1).slice(0, maxDecimals)
        this.text = formattedBase.split(".")[0] + "." + rawDecimal
      } else {
        this.text = formattedBase
      }
      this.text.replace("..", ".")
      this.$emit("input", Number(number))
      this.$emit("keyup")
      this.$emit("change")
    },
  },
}
</script>
